import PropTypes from "prop-types";
import './index.css';

function StyledImagePreview({ imagePreview, imageName }) {
    return (
        <div>
            <div className="content">
                <div className="content-overlay"></div>
                <img className="content-image" src={imagePreview} alt="" />
                <div className="content-details fadeIn-bottom">
                    <h3 className="content-title">{imageName}</h3>
                </div>
            </div>
        </div>
    );
}
StyledImagePreview.defaultProps = {
    imagePreview: "",
    imageName: "",
};
StyledImagePreview.propTypes = {
    imagePreview: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
};


export default StyledImagePreview;